var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaFamilyBased(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#A0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.048 45.925a1 1 0 011-1h9.253a1 1 0 011 1V60.8H42.048V45.925z",
    fill: "#630095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.846 62.943l29-23.71 29 23.71v38.289h-58V62.943z",
    fill: "#F6E3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.966 41.576l-.172-.162a5.815 5.815 0 01-.85-7.458v0a5.815 5.815 0 00-.032-6.498l-.398-.585M45.404 41.597l-.172-.162a5.815 5.815 0 01-.85-7.457v0a5.815 5.815 0 00-.032-6.498l-.398-.586",
    stroke: "#9400DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 34.232l38.003 31.958a1 1 0 01.143 1.383l-4.426 5.638a1 1 0 01-1.43.148L70 46.205 37.71 73.359a1 1 0 01-1.43-.148l-4.426-5.638a1 1 0 01.143-1.383L70 34.232z",
    fill: "#6E00A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 42.129l34.87 29.582-1.068 1.474a1 1 0 01-1.453.179L70 46.207 37.723 73.346a1 1 0 01-1.43-.148l-1.29-1.644L70 42.13z",
    fill: "#630095"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.321 78.72a8.416 8.416 0 01-1.214-4.378c0-4.525 3.515-8.193 7.852-8.193 3.338 0 6.19 2.174 7.326 5.238 1.136-3.064 3.988-5.238 7.326-5.238 4.337 0 7.852 3.668 7.852 8.193a8.4 8.4 0 01-1.437 4.725 14.383 14.383 0 01-1.4 2.413l-.81 1.127a25.124 25.124 0 01-3.316 3.757l-3.202 2.969-2.837 2.303a3.507 3.507 0 01-4.42 0l-2.838-2.303L62 86.363a25.13 25.13 0 01-3.316-3.756l-.81-1.128a14.39 14.39 0 01-1.554-2.759z",
    fill: "#D37AFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.824 101.863h64.044",
    stroke: "#6E00A5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgVisaFamilyBased;